module.exports = __webpack_public_path__ + "img/cleaf2.3e39ce64.jpg";